import { splitByNewLine } from "../strings";
import csvGetItems from "./getItems";

const getData = (data, parameter) => {
  return csvGetItems(splitByNewLine(data), parameter);
};
export default getData;
